<template>
  <div
    class="sidebar fixed h-screen"
    :class="{ 'theme-dark': nightMode, sidebar: !nightMode }"
  >
    <router-link to="/map">
      <div class="mb-10">
        <img
          class="w-4/6 mt-10 mx-auto"
          :src="require(`@/assets/urban-logo-dark.png`)"
        />
      </div>
    </router-link>
    <ul class="menu mt-10 ml-4 mr-4 px-4 flex flex-col text-lg">
      <li
        class="my-4 flex items-center"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="w-6 mr-2">
          <img
            class="object-cover"
            :src="require(`@/assets/${item.icon}.png`)"
          />
        </div>

        <router-link :to="item.link">{{
          $t(`sidebar.menu.${item.name}`)
        }}</router-link>
      </li>
    </ul>
    <div class="absolute bottom-0 left-0 right-0 mb-4">
      <img
        class="w-2/3 mx-auto"
        :src="require(`@/assets/logo-solar.png`)"
      />
    </div>
  </div>
</template>
<script>
/**
 * Componente Sidebar
 * --------------------------------------------
 *
 * Componente que contiene una lista con links a las diferentes rutas para mostrar la vista a la que se quiera navegar.
 *
 */
export default {
  props: ["nightMode"],
  data() {
    return {
      items: [
        { link: "/map", name: "map", icon: "icon-map" },
        {
          link: "/dashboard",
          name: "dashboard",
          icon: "icon-dashboard"
        },
        { link: "/reports", name: "reports", icon: "icon-report" },
        { link: "/alarms", name: "alarms", icon: "icon-alarm" }
      ]
    };
  }
};
</script>
<style scoped>
.sidebar {
  background-color: #2d2d2d;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
.sidebar-title {
  color: white;
}
.router-link-active {
  opacity: 1;
  visibility: visible;
  border-left-color: #fbb03b;
  color: #fbb03b;
  transition: all 0.25s;
}
.sidebar-letter {
  color: #fbb03b;
  font-weight: bolder;
}
.theme-dark {
  background: #2d2d2d;
  color: #dddddd;
}
.menu {
  color: #dddddd;
}
</style>